import { render } from "./TheTruong_HocSinh.vue?vue&type=template&id=82ab2f54"
import script from "./TheTruong_HocSinh.vue?vue&type=script&lang=js"
export * from "./TheTruong_HocSinh.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__